export enum InstallStep {
  TestShot = 'TestShot',
  GeneralConfig = 'GeneralConfig',
  HardwareChanges = 'HardwareChanges',
  ProjectorConfig = 'ProjectorConfig',
  VisionCalibration = 'VisionCalibration',
  BallType = 'BallType',
  Repeatability = 'Repeatability',
  Completion = 'Completion',
  None = '',
}
